/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export enum AffixRespondEvents {
  resize = 'resize',
  scroll = 'scroll',
  touchstart = 'touchstart',
  touchmove = 'touchmove',
  touchend = 'touchend',
  pageshow = 'pageshow',
  load = 'LOAD'
}
